/**
 * Variable product CTA na product card → AJAX add-to-cart (zamiast page reload).
 *
 * WC core `wc-add-to-cart.js` obsługuje tylko `.ajax_add_to_cart` (simple products
 * z `supports('ajax_add_to_cart') === true`). Variable products tej klasy nie
 * dostają, więc klik na CTA z product-card.php był pełnym page reload przez
 * `?add-to-cart=ID&variation_id=...`.
 *
 * Tu obsługujemy `[data-hn-cta][data-variation_id]` — wysyłamy POST do WC AJAX
 * endpoint z product_id + variation_id + atrybutami wariantu (czytanymi z
 * `data-hn-default` na root karcie), potem triggerujemy `added_to_cart` jQuery
 * event z fragments, co spina się z side-cart.js (otwiera drawer).
 *
 * Fallback do navigacji gdy AJAX zfailuje lub WC zwróci błąd (np. out of stock
 * w międzyczasie) — userska zmiana wariantu na PDP załatwi sprawę.
 */

function getWcAjaxUrl() {
    const p = window.wc_add_to_cart_params;
    if (p?.wc_ajax_url) {
        return p.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart');
    }
    // Fallback gdy wc-add-to-cart script zdequeue'owany (homepage, blog itp).
    return '/?wc-ajax=add_to_cart';
}

async function addVariableToCart(btn) {
    const productId   = btn.dataset.product_id;
    const variationId = btn.dataset.variation_id;
    const quantity    = btn.dataset.quantity || '1';

    if (!productId || !variationId || variationId === '0') return false;

    const card = btn.closest('[data-product-id]');
    let attrs = {};
    if (card?.dataset.hnDefault) {
        try { attrs = JSON.parse(card.dataset.hnDefault); } catch (_) { /* ignore */ }
    }

    const fd = new FormData();
    fd.append('product_id', productId);
    fd.append('quantity', quantity);
    fd.append('variation_id', variationId);
    // Każdy atrybut jako osobny POST key: attribute_pa_X=value (WC tego oczekuje).
    Object.entries(attrs).forEach(([k, v]) => fd.append(k, v));

    btn.classList.add('loading');

    try {
        const res = await fetch(getWcAjaxUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            body: fd,
            headers: { 'Accept': 'application/json' },
        });
        const data = await res.json();
        btn.classList.remove('loading');

        if (data.error) {
            // Najczęściej: variation OOS / wymaga większej qty. Fallback do PDP.
            window.location.href = data.product_url || btn.href;
            return true;
        }

        // Trigger event tak jak WC core to robi po sukcesie. side-cart.js
        // łapie ten event (jQuery), bierze fragments, swapuje DOM i otwiera drawer.
        if (window.jQuery && data.fragments) {
            window.jQuery(document.body).trigger(
                'added_to_cart',
                [data.fragments, data.cart_hash, window.jQuery(btn)]
            );
        }
        return true;
    } catch (_) {
        btn.classList.remove('loading');
        // Network error → fallback do default URL (full page nav, gwarantuje że
        // user nie zostaje bez feedbacku).
        window.location.href = btn.href;
        return true;
    }
}

export function initCardVariants() {
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('a[data-hn-cta]');
        if (!btn) return;
        // Tylko warianty z wybranym variation_id — simple products mają osobny
        // CTA bez `data-hn-cta` (z klasą `ajax_add_to_cart`, obsługuje WC core).
        if (!btn.dataset.variation_id || btn.dataset.variation_id === '0') return;

        e.preventDefault();
        addVariableToCart(btn);
    });
}
